{
  "metadata": {
    "id": "gruvbox-dark",
    "name": "Gruvbox",
    "description": "Портировано из темы «Gruvbox» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "gruvbox.json",
      "project": "morhetz",
      "url": "https://github.com/morhetz/gruvbox",
      "upstreamFile": "packages/ui/src/theme/themes/gruvbox.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 20.8,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.309,
      "paletteMaxS": 0.35,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.2,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 21.5,
      "syntaxVsTextMinDeltaE": 25.3,
      "chartsMinDeltaE": 29.0,
      "textSeparationDeltaE": 18.8,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#83a598",
      "hover": "#92b0a4",
      "active": "#9cb7ad",
      "foreground": "#000000",
      "muted": "#83a59880",
      "emphasis": "#83a598"
    },
    "surface": {
      "background": "#282828",
      "foreground": "#ebdbb2",
      "muted": "#3b3a36",
      "mutedForeground": "#b8af99",
      "elevated": "#45433d",
      "elevatedForeground": "#ebdbb2",
      "raised": "#5d594e",
      "raisedForeground": "#ebdbb2",
      "overlay": "#282828cc",
      "subtle": "#31312f"
    },
    "interactive": {
      "border": "#615d51",
      "borderHover": "#5f5a4f",
      "borderFocus": "#83a598",
      "selection": "#ebdbb229",
      "selectionForeground": "#ebdbb2",
      "focus": "#83a59859",
      "focusRing": "#83a59861",
      "cursor": "#ebdbb2",
      "hover": "#ebdbb21c",
      "active": "#ebdbb229"
    },
    "status": {
      "error": "#fb5643",
      "errorForeground": "#000000",
      "errorBackground": "#fb564324",
      "errorBorder": "#fb564373",
      "warning": "#fabd2f",
      "warningForeground": "#000000",
      "warningBackground": "#fabd2f24",
      "warningBorder": "#fabd2f73",
      "success": "#b8bb26",
      "successForeground": "#000000",
      "successBackground": "#b8bb2624",
      "successBorder": "#b8bb2673",
      "info": "#d3869b",
      "infoForeground": "#000000",
      "infoBackground": "#d3869b24",
      "infoBorder": "#d3869b73"
    },
    "pr": {
      "open": "#b8bb26",
      "draft": "#c2bba9",
      "blocked": "#fabd2f",
      "merged": "#fb4934",
      "closed": "#fb5643"
    },
    "syntax": {
      "base": {
        "background": "#4d4b43",
        "foreground": "#ebdbb2",
        "comment": "#d9bfa6",
        "keyword": "#fda398",
        "string": "#2fff33",
        "number": "#e2afbd",
        "function": "#a9c1b8",
        "variable": "#ebdbb2",
        "type": "#f9b006",
        "operator": "#f4f3f0"
      },
      "tokens": {
        "commentDoc": "#d9bfa6",
        "stringEscape": "#f4f3f0",
        "keywordImport": "#fda398",
        "storageModifier": "#fda398",
        "functionCall": "#a9c1b8",
        "method": "#a9c1b8",
        "variableProperty": "#a9c1b8",
        "variableOther": "#ebdbb2",
        "variableGlobal": "#e2afbd",
        "variableLocal": "#f4f3f0",
        "parameter": "#ebdbb2",
        "constant": "#e2afbd",
        "class": "#f9b006",
        "className": "#f9b006",
        "interface": "#f9b006",
        "struct": "#f9b006",
        "enum": "#f9b006",
        "typeParameter": "#f9b006",
        "namespace": "#f9b006",
        "module": "#fda398",
        "tag": "#fda398",
        "jsxTag": "#fda398",
        "tagAttribute": "#a9c1b8",
        "tagAttributeValue": "#2fff33",
        "boolean": "#e2afbd",
        "decorator": "#fda398",
        "label": "#a9c1b8",
        "regexp": "#2fff33"
      }
    },
    "charts": {
      "series": [
        "#83a598",
        "#d3869b",
        "#b8bb26",
        "#fabd2f",
        "#fb5643"
      ]
    },
    "chat": {
      "background": "#282828",
      "userMessage": "#ebdbb2",
      "userMessageBackground": "#45433d",
      "assistantMessage": "#ebdbb2",
      "assistantMessageBackground": "#3b3a36",
      "timestamp": "#c2bba9",
      "divider": "#615d51",
      "typing": "#c2bba9"
    },
    "loading": {
      "spinner": "#83a598",
      "spinnerTrack": "#3b3a36",
      "skeleton": "#3b3a36",
      "shimmer": "#56544a"
    },
    "tools": {
      "background": "#3b3a36",
      "border": "#615d51",
      "headerHover": "#555249",
      "icon": "#83a598",
      "title": "#ebdbb2",
      "description": "#c2bba9",
      "edit": {
        "added": "#b8bb26",
        "addedBackground": "#b8bb2624",
        "removed": "#fb5643",
        "removedBackground": "#fb564324",
        "modified": "#d3869b",
        "modifiedBackground": "#d3869b24",
        "lineNumber": "#c2bba9"
      }
    },
    "markdown": {
      "heading1": "#ebdbb2",
      "heading2": "#ebdbb2",
      "heading3": "#ebdbb2",
      "heading4": "#ebdbb2",
      "link": "#83a598",
      "linkHover": "#92b0a4",
      "inlineCode": "#2fff33",
      "inlineCodeBackground": "#3b3a36",
      "blockquote": "#c2bba9",
      "blockquoteBorder": "#615d51",
      "listMarker": "#83a598bf",
      "bold": "#ebdbb2",
      "italic": "#ebdbb2e6",
      "strikethrough": "#c2bba9",
      "hr": "#615d51"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#d4a8b0",
        "foreground": "#000000",
        "contrast": 10.03
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#ac7556",
        "foreground": "#000000",
        "contrast": 5.43
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#d6c4ab",
        "foreground": "#000000",
        "contrast": 12.34
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#a3a06f",
        "foreground": "#000000",
        "contrast": 7.82
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#96b464",
        "foreground": "#000000",
        "contrast": 9.01
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#b5d7ac",
        "foreground": "#000000",
        "contrast": 13.28
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#5daf74",
        "foreground": "#000000",
        "contrast": 7.85
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#689e8a",
        "foreground": "#000000",
        "contrast": 6.85
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#acd6d7",
        "foreground": "#000000",
        "contrast": 13.35
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#609cb1",
        "foreground": "#000000",
        "contrast": 6.89
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#62749a",
        "foreground": "#ffffff",
        "contrast": 4.68
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#a9a7d2",
        "foreground": "#000000",
        "contrast": 9.15
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8654a8",
        "foreground": "#ffffff",
        "contrast": 5.46
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#b383c1",
        "foreground": "#000000",
        "contrast": 6.93
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#aa558c",
        "foreground": "#ffffff",
        "contrast": 4.79
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#9e6a78",
        "foreground": "#000000",
        "contrast": 4.79
      }
    ]
  }
}
